module.exports = __webpack_public_path__ + "media/logos/SEP-5ad30897.png";